export const visit = (vm, at) => {
at({ "pl": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "Nowa wiadomo\u015B\u0107" } } } });
};